<div class="page-produto-corte container py-4" *ngIf="!carregando && product">
  <div class="corte-page-header d-flex justify-content-between align-items-start flex-wrap gap-2">
    <div>
      
     <!-- <h1 class="h4 mb-1">{{ product.descricao || product.nome || "Produto" }}</h1> -->
      <h1 class="h4 mb-1">{{ tituloProduto }}</h1>
      
      <!-- <p class="text-muted mb-0 small">
        Informe os cortes desejados (comprimento em metros, múltiplos de 0,10 m).
      </p> -->
    </div>
    <button
      type="button"
      class="btn btn-outline-secondary"
      [disabled]="isSalvando"
      (click)="voltar()"
    >
      Fechar
    </button>
  </div>

  <p *ngIf="isSalvando" class="text-muted small mb-0 mt-2">
    Salvando cortes no pedido…
  </p>

  <div class="corte-page-body mt-3" [attr.aria-busy]="isSalvando">
    <app-corte-modalidade-venda
      *ngIf="exibirModalidadeVenda"
      class="d-block mb-3"
      [bloqueado]="isSalvando"
      [medidasFracionado]="medidasFracionadoCorte"
      [medidasIntegral]="medidasIntegralCorte"
      [valorServicoCorte]="valorServicoCorteExibido"
      [precoServicoCorte]="precoServicoCorteExibido"
      [utilizacaoEstoque]="utilizacaoEstoqueModalidade"
      [tipoServicoCorteInicial]="tipoServicoCorteInicial"
      (selecaoChange)="onModalidadeVendaChange($event)"
    ></app-corte-modalidade-venda>

    <app-corte-form
      [editando]="editando"
      [cores]="coresProduto"
      [tamanhos]="tamanhosProduto"
      [corSelecionada]="corSelecionada"
      [tamanhoSelecionado]="tamanhoSelecionado"
      [bloqueado]="isSalvando"
      (adicionar)="onAdicionar($event)"
      (cancelarEdicao)="onCancelarEdicaoForm()"
    ></app-corte-form>

    <app-corte-resumo
      class="d-block mt-3"
      [itens]="itens"
      [produto]="produtoResumo"
      [productDetalhe]="product"
      [precoTabela]="precoUnitarioCorte"
      [corteBloco]="corteBlocoApi"
      [editandoId]="editandoId"
      [bloqueado]="isSalvando"
      (editar)="onEditar($event)"
      (excluir)="onExcluir($event)"
      (itensDerivados)="onItensDerivados($event)"
      (devolucaoAcao)="onDevolucaoAcao($event)"
    ></app-corte-resumo>
  </div>

  <!-- <div class="corte-page-footer mt-4 d-flex flex-wrap gap-2 justify-content-end">
     <button type="button" class="btn btn-outline-secondary" (click)="voltar()">
      Voltar
    </button> 
    <button
      type="button"
      class="btn btn-primary"
      [disabled]="itens.length === 0"
      (click)="confirmar()"
    >
      Salvar
    </button>
  </div> -->
</div>

<div class="container py-5 text-center text-muted" *ngIf="carregando">
  Carregando…
</div>
